import { isEqual } from 'lodash';

import { SetState } from '@app/constants';

export interface RecordsData<T> {
  pageNumber: number;
  records?: T[];
  setPages: SetState<T[][]>;
}

export const setPageRecords = <T>({
  pageNumber,
  records = [],
  setPages,
}: RecordsData<T>) => {
  setPages((prevState = []) => {
    const newPages = Array.from(prevState);

    if (!isEqual(newPages[pageNumber - 1], records)) {
      newPages[pageNumber - 1] = records;
    }

    return newPages;
  });
};
